import { AxiosInstance, AxiosRequestConfig } from 'axios'

import { apiClient } from '../../../apiClient'
import { Pagination, Response } from './types'

class SankalpSheetApi {
  private api: AxiosInstance

  constructor(config: AxiosRequestConfig) {
    this.api = apiClient.create(config)
  }

  getStoreListPageSankalp = (params: object) =>
    this.api.get<Response<any>>(`/gw2/puja/internal/v1/sankalp/store-list`, {
      params: params,
    })

  getSankalpStoreDetails = (store_id: string) =>
    this.api.get<Response<any>>(
      `/gw2/puja/internal/v1/sankalp/store/${store_id}`,
    )

  getBatchInventoryData = (inventory_id: string, params: object) =>
    this.api.get<Response<any>>(
      `/gw2/puja/internal/v1/sankalp/${inventory_id}`,
      { params: params },
    )

  // transliterateInventory = (inventory_id: string, payload: any) =>
  //   this.api.post<any>(
  //     `/gw2/puja/internal/v1/sankalp/${inventory_id}/transliterate`,
  //     payload,
  //   )

  transliterateInventory = (store_id: string, payload: any) =>
    this.api.post<any>(
      `/gw2/puja/internal/v1/sankalp/store/${store_id}/transliterate`,
      payload,
    )

  exportSankalpSheet = (payload: any) =>
    this.api.post<any>(`/gw2/puja/internal/v1/sankalp/export`, payload)

  transliterateInventoryQc = (payload: any, inventory_id: string) =>
    this.api.patch<any>(
      `/gw2/puja/internal/v1/sankalp/${inventory_id}/transliterate`,
      payload,
    )
}

export default SankalpSheetApi
